module.exports = __webpack_public_path__ + "static/Kannan-Ranganathan-5a08851dc148a6e18ae3de65d712ab76.jpg";